import map from 'lodash/map'
import get from 'lodash/get'

export function parse(entry) {
    const entryType = get(entry, 'sys.type')
    if ('Entry' === entryType) {
        const contentType = get(entry, 'sys.contentType.sys.id')
        const entryContentType = get(entry, 'sys.contentType.sys.id')
        if (contentType && entryContentType) {
            switch (entryContentType) {
                case 'widgetHeroBlock':
                    return parseWidgetHeroBlock(entry)
                case 'widgetHeroPTP':
                    return parseWidgetHeroBlockPTP(entry)
                case 'widgetStoryBlockPTP':
                    return parseWidgetStoryBlockPTP(entry)
                case 'widgetStoryBlock':
                    return parseWidgetStoryBlock(entry)
                case 'searchPanel':
                    return parseWidgetSearchPanel(entry)
                case 'widgetSearchPanelPTP':
                    return parseWidgetSearchPanelPTP(entry)
                case 'pagesGroup':
                    return parseWidgetPagesGroup(entry)
                case 'pageGroupPTP':
                    return parseWidgetPagesGroupPTP(entry)
                case 'widgetDonate':
                    return parseWidgetDonate(entry)
                case 'widgetLinks':
                    return parseWidgetLinks(entry)
                case 'widgetLinksPTP':
                    return parseWidgetLinksPTP(entry)
                case 'widgetRichText':
                    return parseWidgetRichText(entry)
                case 'widgetRichTextPtp':
                    return parseWidgetRichTextPTP(entry)
                case 'widgetLinkBlock':
                    return parseWidgetLinkBlock(entry)
                case 'widgetLinkBlockPTP':
                    return parseWidgetLinkBlockPTP(entry)
                case 'widgetImpact':
                    return parseWidgetImpact(entry)
                case 'widgetImpactPTP':
                    return parseWidgetImpactPTP(entry)
                case 'widgetSocialFeed':
                    return parseWidgetSocialFeed(entry)
                case 'widgetSocialFeedPTP':
                    return parseWidgetSocialFeedPTP(entry)
                case 'widgetBanner':
                    return parseWidgetBanner(entry)
                default:
                    const message = `Can't parse entry type ${entry.sys.contentType.sys.id}, please check the code and update`
                    console.error(message)
                    return entry.fields || message
            }
        }
    }
}

function parseWidgetStoryBlock(entry) {
    return {
        __typename: 'ContentfulWidgetStoryBlock',
        ...entry.fields,
        backgroundImage: entry.fields.backgroundImage.fields,
        story: entry.fields.story.fields,
    }
}
function parseWidgetStoryBlockPTP(entry) {
    return {
        __typename: 'ContentfulWidgetStoryBlockPtp',
        ...entry.fields,
        backgroundImage: entry.fields.backgroundImage.fields,
    }
}

function parseWidgetHeroBlock(entry) {
    return {
        __typename: 'ContentfulWidgetHero',
        ...entry.fields,
        backgroundImage: entry.fields.backgroundImage.fields,
        summary: {
            raw: entry.fields.summary,
        },
        link: get(entry, 'fields.link.fields'),

        featureList: map(entry.fields.featureList, (feature) => {
            if (feature.__typename === 'widgetStoryBlock') {
                return parseWidgetStoryBlock(feature)
            } else {
                const linkBlock = parseWidgetLinkBlock(feature)
                return {
                    ...linkBlock,
                    featureLink: linkBlock.link,
                }
            }
        }),
    }
}
function parseWidgetHeroBlockPTP(entry) {
    return {
        __typename: 'ContentfulWidgetHeroPtp',
        ...entry.fields,
        backgroundImage: entry.fields.backgroundImage.fields,
        summary: {
            raw: entry.fields.summary,
        },
        link: get(entry, 'fields.link.fields'),

        featureList: map(entry.fields.featureList, (feature) => {
            if (feature.__typename === 'widgetStoryBlockPTP') {
                return parseWidgetStoryBlock(feature)
            } else {
                const linkBlock = parseWidgetLinkBlock(feature)
                return {
                    ...linkBlock,
                    featureLink: linkBlock.link,
                }
            }
        }),
    }
}

function parseWidgetSearchPanel(entry) {
    return {
        __typename: 'ContentfulWidgetSearchPanel',
        ...entry.fields,
        bgImage: entry.fields.bgImage.fields,
        featureList: map(entry.fields.featureList, (feature) => {
            if (feature.__typename === 'widgetStoryBlock') {
                return parseWidgetStoryBlock(feature)
            } else {
                const linkBlock = parseWidgetLinkBlock(feature)
                return {
                    ...linkBlock,
                    featureLink: linkBlock.link,
                }
            }
        }),
    }
}
function parseWidgetSearchPanelPTP(entry) {
    return {
        __typename: 'ContentfulWidgetSearchPanelPtp',
        ...entry.fields,
        bgImage: entry.fields.bgImage.fields,
        featureList: map(entry.fields.featureList, (feature) => {
            if (feature.__typename === 'widgetStoryBlockPTP') {
                return parseWidgetStoryBlock(feature)
            } else {
                const linkBlock = parseWidgetLinkBlock(feature)
                return {
                    ...linkBlock,
                    featureLink: linkBlock.link,
                }
            }
        }),
    }
}
function parseWidgetPagesGroup(entry) {
    return {
        __typename: 'ContentfulPageGroup',
        contentful_id: entry.sys.id,
        ...entry.fields,
        image: entry.fields.image ? entry.fields.image.fields : null,
    }
}
function parseWidgetPagesGroupPTP(entry) {
    return {
        __typename: 'ContentfulPageGroupPtp',
        contentful_id: entry.sys.id,
        ...entry.fields,
        image: entry.fields.image ? entry.fields.image.fields : null,
    }
}

function parseWidgetDonate(entry) {
    return {
        __typename: 'ContentfulWidgetDonate',
        ...entry.fields,
        notice: {
            notice: entry.fields.notice,
        },
    }
}

function parseWidgetLinks(entry) {
    return {
        __typename: 'ContentfulWidgetLinks',
        ...entry.fields,
        image: entry.fields.image.fields,
        links: parseLinkList(entry.fields.links),
    }
}
function parseWidgetLinksPTP(entry) {
    return {
        __typename: 'ContentfulWidgetLinksPtp',
        ...entry.fields,
        image: entry.fields.image.fields,
        links: parseLinkList(entry.fields.links),
    }
}
function parseWidgetRichText(entry) {
    return {
        __typename: 'ContentfulWidgetRichText',
        ...entry.fields,
        content: {
            raw: entry.fields.content,
        },
    }
}
function parseWidgetRichTextPTP(entry) {
    return {
        __typename: 'ContentfulWidgetRichTextPtp',
        ...entry.fields,
        content: {
            raw: entry.fields.content,
        },
    }
}

function parseWidgetLinkBlock(entry) {
    return {
        __typename: 'ContentfulWidgetLinkBlock',
        ...entry.fields,
        summary: {
            summary: entry.fields.summary,
        },
        backgroundImage: entry.fields.backgroundImage.fields,
        buttonLink: parseLinkList(entry.fields.link),
    }
}
function parseWidgetLinkBlockPTP(entry) {
    return {
        __typename: 'ContentfulWidgetLinkBlockPtp',
        ...entry.fields,
        summary: {
            summary: entry.fields.summary,
        },
        backgroundImage: entry.fields?.backgroundImage?.fields,
        buttonLink: parseLinkList(entry.fields.link),
    }
}

export function MapTypeToTypename(entry) { 
    let typename
    const contentType = get(entry, 'sys.contentType.sys.id')
    if (contentType === 'genericPage') {
        typename = 'ContentfulPageGeneric'
    }  else if (contentType === 'guideline') {
        typename = 'ContentfulPageGuideline'
    } else if (contentType === 'pageStory') {
        typename = 'ContentfulPageStory'
    } else if (contentType === 'widgetsPage') {
        typename = 'ContentfulPageWidgets'
    } else if (contentType === 'pagesGroup') {
        typename = 'ContentfulPageGroup'
    } else if (contentType === 'directoryOfServices') {
        typename = 'ContentfulPageDirectoryOfServices'
    } else if (contentType === 'customPage') {
        typename = 'ContentfulPageCustom'
    } else if (contentType === 'pageDonation') {
        typename = 'ContentfulPageDonation'
    } else if (contentType === 'link') {
        typename = 'ContentfulWidgetLink'
    } else if (contentType === 'widgetLinkPTP') {
        typename = 'ContentfulWidgetLinkPtp'
    } else if (contentType === 'pageGenericPTP') {
        typename = 'ContentfulPageGenericPtp'
    } else if (contentType === 'pageDirectoryOfServicesPTP') {
        typename = 'ContentfulPageDirectoryOfServicesPtp'
    } else if (contentType === 'pageGroupPTP') {
        typename = 'ContentfulPageGroupPtp'
    } else if (contentType === 'pageWidgetsPTP') {
        typename = 'ContentfulPageWidgetsPtp'
    } else if (contentType === 'pageBlog') {
        typename = 'ContentfulPageBlog'
    }
    return typename
}


export function parseLinkList(linkList) {
    function parseLink(link) {
        const typename = MapTypeToTypename(link)

        const linkObj = {
            ...link.fields,
            __typename: typename,
        }

        if (link?.fields?.icon) {
            linkObj.icon = link.fields.icon.fields
        }

        return linkObj
    }

    if (Array.isArray(linkList)) {
        return linkList.map(parseLink)
    } else if (typeof linkList === 'object' && linkList !== null) {
        return parseLink(linkList)
    }

    return null
}

function parseWidgetImpact(entry) {
    return {
        __typename: 'ContentfulWidgetImpact',
        ...entry.fields,
        introduction: {
            introduction: entry.fields.introduction,
        },
        items: parseLinkList(entry.fields.items),
        link: entry.fields.link.fields,
    }
}
function parseWidgetImpactPTP(entry) {
    return {
        __typename: 'ContentfulWidgetImpactPtp',
        ...entry.fields,
        introduction: {
            introduction: entry.fields.introduction,
        },
        items: parseLinkList(entry.fields.items),
        link: entry.fields.link.fields,
    }
}

function parseWidgetSocialFeed(entry) {
    return {
        __typename: 'ContentfulWidgetSocialFeed',
        ...entry.fields,
    }
}
function parseWidgetSocialFeedPTP(entry) {
    return {
        __typename: 'ContentfulWidgetSocialFeedPtp',
        ...entry.fields,
    }
}

function parseWidgetBanner(entry) {
    return {
        ...entry.fields,
        __typename: 'ContentfulWidgetBanner',
        description: {
            description: entry.fields.description,
        },
        backgroundImage: entry.fields.backgroundImage.fields,
    }
}
